<template lang="pug">
#app
  #wrapper
    p.summary 朝日小学生新聞・朝日中高生新聞のウェブサイトです。
    Header(:isOpenModal.sync="isOpenModal")
    .main
      router-view
    Footer
  #modal(v-if="isOpenModal")
    .modal-inner
      p.summary 朝日小学生新聞・朝日中高生新聞のウェブサイトです。
      a.btn-modal-close(@click="onClickClose")
      Header
</template>

<style lang="scss">
@import "./assets/scss/foundation/funcs";
@import "./assets/scss/foundation/reset";
@import "./assets/scss/foundation/base";

@mixin flex($jc: space-between) {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  justify-content: $jc;
}

.summary {
  font-size: 12px;
  line-height: 30px;
  text-align: center;
  color: #fff;
  background: #000;
}
#app {
  opacity: 0;
}
#wrapper {
  header {
    .footnav {
      display: none;
    }
    nav {
      li {
        position: relative;
        &:before {
          display: block;
          width: 100%;
          height: 13px;
          position: absolute;
          bottom: -8px;
        }
      }
    }
    &.top {
      h1 {
        display: none;
      }
      nav {
        margin-left: 24%;
      }
    }
    &.concour,
    &.concour-detail {
      li.concour {
        opacity: 1 !important;
        a {
          pointer-events: none;
        }
        &:before {
          content: " ";
          background: url(assets/img/common/gnav_current01.png) no-repeat center
            bottom;
        }
      }
    }
    &.teaching,
    &.teaching-detail {
      li.teaching {
        opacity: 1 !important;
        a {
          pointer-events: none;
        }
        position: relative;
        &:before {
          content: " ";
          background: url(assets/img/common/gnav_current02.png) no-repeat center
            bottom;
        }
      }
    }
    &.event,
    &.event-detail {
      li.event {
        opacity: 1 !important;
        a {
          pointer-events: none;
        }
        position: relative;
        &:before {
          content: " ";
          background: url(assets/img/common/gnav_current03.png) no-repeat center
            bottom;
        }
      }
    }
  }
  .card-area {
    @include flex();
  }
  .card:nth-of-type(1),
  .card:nth-of-type(2),
  .card:nth-of-type(3) {
    margin-top: 0;
  }
  .pagetop {
    font-size: 12px;
    font-weight: bold;
    letter-spacing: 0.06em;
    max-width: 1000px;
    padding: 0 10px;
    text-align: right;
    margin: 60px auto 30px;
    padding-left: 22px;
    a {
      &:before {
        content: " ";
        width: 0;
        height: 0;
        display: inline-block;
        margin-right: 10px;
        border: 6px dashed transparent;
        border-bottom: 9px solid #000;
      }
    }
  }
}
.select-area {
  @include flex();
  align-items: flex-end;
  > div {
    width: 40.817%;
    position: relative;
    label {
      -webkit-transform: perspective(1);
      display: block;
      font-size: 14px;
      font-weight: bold;
      text-shadow: 0 2px 1px #fff, 2px 0 1px #fff, 0 -2px 1px #fff,
        -2px 0 1px #fff, -2px -2px 1px #fff, 2px -2px 1px #fff,
        -2px 2px 1px #fff, 2px 2px 1px #fff;
      line-height: 1;
      margin-bottom: 10px;
      letter-spacing: 0.2em;
    }
    .select-box {
      border: 1px solid #000;
      overflow: hidden;
      position: relative;
      select {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        border-radius: 0;
        margin: 0;
        border: none;
        background: #fff;
        font-size: 15px;
        padding: 0.52em 0 0.52em 10px;
        max-height: 40px;
        width: 100%;
        font-weight: bold;
        font-family: "Noto Sans Japanese";
        cursor: pointer;
      }
      span {
        display: block;
        width: 40px;
        height: 40px;
        position: absolute;
        top: 0;
        right: 0;
        pointer-events: none;
        &:before {
          content: " ";
          display: block;
          width: 0;
          height: 0;
          border: 8px dashed transparent;
          border-top: 12px solid #fff;
          position: absolute;
          top: calc(50% - 4px);
          left: calc(50% - 8px);
        }
      }
    }
  }
  .search-btn {
    background: #fff;
    width: 90px;
  }
  input {
    width: 100%;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border-radius: 0;
    margin: 0;
    padding: 0;
    border: 1px solid #000;
    line-height: 2.55;
    font-family: "Noto Sans Japanese";
    font-size: 15px;
    color: #fff;
    font-weight: 500;
    letter-spacing: 0.2em;
    text-indent: 2em;
    background-image: url(./assets/img/common/ico_search.png);
    background-repeat: no-repeat;
    background-size: 21px auto;
    background-position: 17px 8px;
    cursor: pointer;
  }
}
.bottom-nav {
  background: #fff;
  padding: 30px 0;
  border-bottom: 1px solid #ddd;
  ul {
    @include flex();
    width: 340px;
    box-sizing: border-box;
    margin: 0 auto;
  }
  a {
    display: block;
    font-size: 18px;
    font-weight: bold;
    line-height: 1;
    text-align: center;
    span {
      display: inline-block;
      padding: 20px 0;
      letter-spacing: 0;
    }
  }
  .concour span {
    background: url(./assets/img/common/menu_ico01.png) no-repeat left center;
    background-size: 44px auto;
    padding-left: 60px;
  }
  .teaching span {
    background: url(./assets/img/common/menu_ico02.png) no-repeat left center;
    background-size: 44px auto;
    padding-left: 60px;
  }
  .event span {
    background: url(./assets/img/common/menu_ico03.png) no-repeat left center;
    background-size: 26px auto;
    padding-left: 35px;
  }

  @media only screen and (max-width: 750px) {
    background: none;
    border: none;
    padding: 9.5vw 0 13.5vw;
    ul {
      width: 100% !important;
    }
    li {
      width: 48%;
    }
    a {
      background: #fff;
      border-right: 2px solid #b6b6b6;
      border-bottom: 2px solid #b6b6b6;
      text-align: center;
      box-sizing: border-box;
      span {
        padding-left: 12vw !important;
        font-size: 1.451rem;
        padding: 7vw 0;
      }
    }
    .concour span {
      background-size: 9.6vw auto;
    }
    .teaching span {
      background-size: 10.1vw auto;
    }
    .event span {
      background-size: 7vw auto;
      background-position: 10px center;
    }
  }
}
.rounded-btn,
.to-list-btn,
.download-btn,
.more {
  display: block;
  margin: 0 auto;
  background: #fff;
  font-size: 15px;
  font-weight: bold;
  line-height: 50px;
  text-align: center;
  border-radius: 50px;
  a {
    display: block;
    border-radius: 50px;
    width: calc(100% + 2px);
    position: relative;
    left: -1px;
    -webkit-transform: perspective(1);
  }
  span {
    letter-spacing: 0.08em;
    display: inline-block;
    position: relative;
    &:before {
      display: inline-block;
      width: 0;
      height: 0;
      position: absolute;
      top: calc(50% - 8px);
    }
  }
}
.modal {
  display: none;
}
.sp {
  display: none;
}

@media only screen and (max-width: 750px) {
  $white-border2: 0 1px 1px #fff, 1px 0 1px #fff, 0 -1px 1px #fff,
    -1px 0 1px #fff, -1px -1px 1px #fff, 1px -1px 1px #fff, -1px 1px 1px #fff,
    1px 1px 1px #fff;
  .sp {
    display: block;
  }
  .pc {
    display: none;
  }
  .main {
    padding: 0 5.35vw;
  }
  .summary {
    font-size: 0.8rem;
    line-height: 6vw;
    + header {
      .inner {
        padding: 0;
        .logo {
          border-bottom: 1px solid #e5e5e5;
        }
        nav,
        .footnav,
        .sns {
          display: none;
        }
      }
      &.top {
        .inner {
          display: none;
        }
      }
    }
  }
  #wrapper {
    .card-area {
      display: block;
      .card:first-child {
        margin-top: 0 !important;
      }
    }
    .pagetop {
      display: none;
    }
  }

  .rounded-btn,
  .to-list-btn,
  .download-btn,
  .more {
    width: 100% !important;
    font-size: 1.28rem;
    line-height: 1;
    a {
      position: static;
      width: 100%;
      border: none !important;
    }
    span {
      padding: 4.8vw 0;
      &:before {
        top: calc(50% - 1.5vw);
      }
    }
  }
  // modal
  #modal {
    .summary {
      display: none;
    }
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: #ffffff;
    .modal-inner {
      position: relative;
      overflow-y: scroll;
      width: 100%;
      height: 100%;
      a.btn-modal-close {
        right: 5.35vw;
        display: block;
        width: 5.6vw;
        height: 5.6vw;
        position: absolute;
        z-index: 2;
        background: url(./assets/img/common/menu_close.png) no-repeat left
          center;
        background-size: 100% auto;
        margin: 4.5vw 0;
      }
      header {
        .btn-ham {
          display: none;
        }
        .footnav {
          display: block;
          border-bottom: 1px solid #e5e5e5;
        }
      }
    }
  }
  .select-area {
    flex-wrap: wrap;
    > div {
      width: 48.5%;
      label {
        letter-spacing: 0.1em;
        text-shadow: $white-border2;
        font-size: 1.28rem;
      }
      .select-box {
        select {
          font-size: 1.03rem;
          padding: 8px 0 8px 10px;
          line-height: 1;
          max-height: none;
        }
        span {
          width: 8.6vw;
          height: 100%;
          box-sizing: content-box;
          &:before {
            border: 1vw dashed transparent;
            border-top: 1.6vw solid #fff;
            top: calc(50% - 0.6vw);
            left: calc(50% - 0.8vw);
          }
        }
      }
    }
    .search-btn {
      width: 100%;
      margin-top: 4.5%;
    }
    input {
      font-size: 1.46rem;
      background-position: 34vw 0.7em;
      background-size: 5.4vw auto;
      text-indent: 1.6em;
    }
  }
  body {
    &.menu-fixed {
      .summary + header {
        position: fixed;
        top: 0;
        z-index: 999;
        &:not(.top) + .main {
          padding-top: 14.5vw;
        }
      }
      header.top {
        .inner, h1 {
          display: block !important;
        }
      }
    }
    &.modal-top {
      #modal .summary {
        display: block;
      }
    }
  }
}
</style>

<script>
import $ from "jquery";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Gnav from "./components/Gnav";
export default {
  data: () => {
    return {
      current_scrollY: 0,
      isOpenModal: false
    };
  },
  components: {
    Header,
    Footer,
    Gnav
  },
  watch: {
    isOpenModal(bool) {
      if (bool) {
        this.current_scrollY = $(window).scrollTop();
        if (this.current_scrollY == 0) {
          $("body").addClass("modal-top");
        } else {
          $("body").removeClass("modal-top");
        }
        $("#wrapper").css({
          position: "fixed",
          width: "100%",
          top: -1 * this.current_scrollY
        });
        $("#modal").show();
      } else {
        $("#wrapper").attr({ style: "" });
        $("html, body").prop({ scrollTop: this.current_scrollY });
        $("#modal").hide();
      }
    }
  },
  methods: {
    onClickClose() {
      this.isOpenModal = false;
    }
  },
  mounted: function() {
    // TODO これはindex.htmlに直書きか、ua.jsなどを作ってheadの上の方で呼ぶ
    var u = window.navigator.userAgent.toLowerCase();
    if (
      u.indexOf("ipad") != -1 ||
      (u.indexOf("android") != -1 && u.indexOf("mobile") == -1)
    ) {
      $("meta[name='viewport']").attr("content", "width=1024");
    }

    $("header").addClass(
      $(".main")
        .children()
        .prop("class")
    );

    // FIXED vue.jsで実装するので削除
    // $(".tab-btn .btn:not(.none)").on("click", function() {
    //   if (!$(this).hasClass("show")) {
    //     $(".show").removeClass("show");
    //     $(this).addClass("show");
    //     $(".tab-contents").hide();
    //     var $e = $(".tab-contents").eq($(this).index());
    //     $e.fadeIn(400);
    //     txtOverflow($e.find(".txt-overflow"));
    //   }
    // });

    // FIXED /utils/ComponentUtil.jsに移動。card.vueから呼び出す
    // function txtOverflow(e) {
    //   e.each(function() {
    //     var $target = $(this);
    //     var html = $target.html();
    //     var $clone = $target.clone();
    //     $clone
    //       .css({
    //         display: "none",
    //         position: "absolute",
    //         overflow: "visible"
    //       })
    //       .width($target.width())
    //       .height("auto");
    //     $target.after($clone);
    //     while (html.length > 0 && $clone.height() > $target.height()) {
    //       html = html.substr(0, html.length - 1);
    //       $clone.html(html + "...");
    //     }
    //     $target.html($clone.html());
    //     $clone.remove();
    //   });
    // }

    function smoothScroll() {
      $(".pagetop a").on("click", function() {
        var speed = 500;
        var href = $(this).attr("href");
        var target = $(href == "#" || href == "" ? "html" : href);
        if (!target.offset()) {
          return;
        }
        var position = target.offset().top;
        $("body,html").animate(
          {
            scrollTop: position
          },
          speed,
          "swing"
        );
        return false;
      });
    }
    smoothScroll();
    $(document).on("scroll", function() {
      var scr = $(window).scrollTop();
      var w = $(window).width();
      var h = $(".main").children().hasClass("top")? w * 0.5: w * 0.06;
      if (scr > h) {
        $("body").addClass("menu-fixed");
      } else {
        $("body").removeClass("menu-fixed");
      }
    });

    // FIXED /utils/ComponentUtil.jsに移動。card.vueから呼び出す
    // $(window).on("resize", function() {
    //   txtOverflow($(".txt-overflow"));
    // });

    // TODO フェードイン表示はvue.jsのトランジションタグでやる
    // @see https://jp.vuejs.org/v2/guide/transitions.html
    $(window).on("load", function() {
      //   txtOverflow($(".txt-overflow"));
      $("#app").animate({ opacity: 1 }, 400);
    });
  }
};
</script>
